import { useEffect } from 'react';
import { Canvas, FabricObject } from 'fabric';

type SyncFn = (pieceId: string, props: Record<string, unknown>) => void;

export const useCrossResolutionSync = (canvas: Canvas | null, sync: SyncFn): void => {
  useEffect(() => {
    if (!canvas) return;

    const handleModified = (e: { target?: FabricObject }) => {
      const obj = e.target;
      if (!obj || !obj.pieceId) return;
      if (obj.linkedAcrossResolutions === false) return;

      const props: Record<string, unknown> = {
        scaleX: obj.scaleX,
        scaleY: obj.scaleY
      };
      if (obj.groupCollection) props.groupCollection = obj.groupCollection;

      sync(obj.pieceId, props);
    };

    canvas.on('object:modified', handleModified);
    return () => {
      canvas.off('object:modified', handleModified);
    };
  }, [canvas, sync]);
};
